export default {
    chat: {
    // 标题
        title: '聊天',
        hiroTitle: 'Hiro',
        hiroSubtitle: '撰写助手',
        figuresSubtitle: '附图助手',
        taskProcessing: '任务处理中',
        planDefaultTitle: '执行计划',
        planStepFallback: '步骤 {index}',
        planTypes: {
            Free: '免费版',
            Internal: '内部版',
            Pro: 'Pro',
            Enterprise: '企业版',
        },

        // 欢迎页面
        welcome: {
            title: '你好！我是 Hiro',
        },
        hiroIntro: '你的智能专利撰写助手，专注于帮助你高效完成专利申请文件的撰写和审查。',
        disclaimer: 'AI生成仅供参考',
        readOnlyWarning: '权限不足：您只有只读权限',

        // 角色
        role: {
            user: '您',
            assistant: 'AI 助手',
            system: '系统',
        },

        // 状态
        status: {
            connected: '已连接',
            connecting: '连接中...',
            disconnected: '未连接',
            error: '连接失败',
        },

        // 后端任务状态
        taskStatus: {
            PENDING: '等待执行',
            STARTED: '执行中',
            SUCCESS: '执行成功',
            FAILURE: '执行失败',
            RETRY: '重试中',
            REVOKED: '已取消',
            INTERRUPTED: '已中断',
        },

        // 思考状态
        thinking: {
            active: '思考中',
            completed: '思考完成',
        },

        // Agent 流程
        agentFlow: {
            completed: '已完成',
            processing: '处理中',
            pending: '待处理',
        },

        // 能力介绍
        capabilities: {
            question: 'Hiro 可以帮您做什么？',
        },

        // 空状态
        empty: {
            tryExamples: '快速开始 - 试试这些示例',
        },

        // 示例问题
        examples: [
            '帮我撰写一份关于智能手机折叠屏技术的发明专利申请',
            '分析这份 OA 通知书中的审查意见',
            '优化权利要求书的撰写，使其更加清晰和完整',
            '根据技术交底书生成说明书',
        ],

        // 附图 Agent 欢迎页
        figuresIntro: '你的附图生成助手，可以根据专利文稿自动规划和绘制专利附图。',
        figuresExamples: [
            '根据已有材料进行附图',
            '为权利要求中的主要技术特征生成结构示意图',
            '优化现有附图，使其更符合专利规范',
            '根据技术交底书生成附图清单',
        ],

        // 输入框
        input: {
            placeholder: {
                default: '输入消息... 使用 {\'@\'} 添加引用',
                disabled: '输入已禁用，请稍候...',
                sending: '正在发送消息...',
            },
            placeholderDisabled: '请等待 Hiro 完成当前任务...',
            placeholderWaiting: '等待回复中...',
            send: '发送',
            stop: '停止执行',
            waiting: '处理中',
            selectedText: '已选择文本',
            clearSelection: '清除选择',
            disabledFooter: 'Hiro 正在处理，请稍候...',
            keys: {
                instruct: '指令',
                generate: '生成',
                edit: '编辑',
                upload: '上传',
            },
            workMode: {
                agent: '智能体',
                copilot: '助手',
            },
            dropToUpload: '拖放文件到此处上传',
            upgrade: '升级',
        },

        // 文件上传
        upload: {
            title: '上传文件',
            choose: '选择文件上传',
            hint: '拖拽文件到此处，或点击选择...',
            uploading: '上传中...',
            success: '上传成功',
            error: '上传失败，请重试',
            successMessage: '文件 {fileName} 上传成功',
            uploadingMultiple: '正在上传 {total} 个文件...',
            allSuccess: '成功上传 {count} 个文件',
            partialSuccess: '成功 {success} 个，失败 {fail} 个',
            filePromptSuffix: '阅读这些文件，总结其中内容对当前任务的影响，生成下一步建议。',
        },

        // 对话历史
        history: {
            title: '对话历史',
            empty: '暂无对话历史',
            search: '搜索对话',
            rename: '重命名',
            delete: '删除',
            defaultTitle: '新对话',
            deleteConfirm: '确认删除此对话吗？',
            inputErrorMessage: '请输入对话标题',
            renameSuccess: '重命名成功',
            // 日期分组标签
            today: '今天',
            yesterday: '昨天',
            lastWeek: '最近一周',
            lastMonth: '最近一个月',
            older: '更早',
        },

        // 操作按钮
        actions: {
            copy: '复制',
            copyText: '复制为文本',
            copyMarkdown: '复制为 Markdown',
            copyOptions: '复制选项',
            copySuccess: '已复制到剪贴板',
            copyFailed: '复制失败',
            noContentToCopy: '没有可复制的内容',
            exportToWord: '导出为 Word',
            exporting: '正在生成 Word 文档...',
            exportSuccess: 'Word 文档已下载',
            exportFailed: '导出失败，请重试',
            mergeToDocument: '合并到文档',
            mergeToDocumentTooltip: '将此内容合并写入当前文档',
            newChat: '新对话',
            selectLanguage: '设置AI输出语言',
            languageLabel: '模型输出语言',
            expandFullContent: '展开查看完整内容',
            enterFullscreen: '进入全屏',
            exitFullscreen: '退出全屏',
        },

        newChatConfirm: {
            message: 'Hiro将开启一个新对话，并将当前对话历史保存在Chat History中。',
        },

        // 任务未完成提醒
        incompleteTasksDialog: {
            title: '任务尚未完成',
            description: '当前任务计划中还有未完成的步骤：',
            bannerText: '任务已暂停，仍有未完成步骤',
            completedLabel: '已完成',
            incompleteLabel: '未完成',
            continueBtn: '继续执行任务',
            endBtn: '结束任务',
            continueMessage: '请继续执行剩余的任务步骤',
            endMessage: '将所有任务计划步骤标记为已完成，然后结束任务',
            inputPlaceholder: '补充说明（可选）',
        },

        // 消息
        messages: {
            sendFailed: '发送消息失败，请重试',
            connecting: '正在连接聊天...',
            applyingTemplate: '正在应用模板...',
            templateAppliedSuccess: '已成功应用模板：{name}',
            templateApplyFailed: '应用模板失败，请重试',
            editorNotInitialized: '编辑器未初始化，无法应用模板',
            modeChanged: '工作模式已切换',
            modeChangeFailed: '切换工作模式失败',
            modeSwitchNotice: '已从 {from} 模式切换到 {to} 模式',
            modeWillBeSetOnSend: '工作模式将在发送第一条消息时生效',
            loadHistoryFailed: '加载对话历史失败',
            createFailed: '创建对话失败',
            deleteFailed: '删除对话失败',
            renameFailed: '重命名对话失败',
            permissionDenied: '您当前没有使用{agentName}的权限，请联系销售升级套餐。',
            permissionDeniedOverseas: '您当前没有使用{agentName}的权限，请{upgradeLink}。',
            upgradePlan: '升级套餐',
            limitExceeded: '使用次数已达上限，请升级套餐或明天再试。',
            limitExceededOverseas: '使用次数已达上限，请{upgradeLink}或明天再试。',
            limitExceededGuest: '使用次数已达上限，请注册账号或明天再试。',
            taskInProgress: '您有另一个任务正在执行中，请等待执行完毕后再提交。',
            globalTaskLimitExceeded: '当前系统负载过高，请稍后再试。',
            interruptFailed: '中断请求失败，请重试',
            contentFilter: '输入内容包含敏感词，请修改后重试。',
        },

        // 输入框状态条
        composerStatus: {
            idle: '等待输入…',
            sending: '正在思考…',
            running: '正在执行…',
            runningWithEstimate: '正在执行，已运行 {elapsed}，预计约 {estimated}',
            runningWithElapsed: '正在执行，已运行 {elapsed}',
            runningLongTask: '正在处理多步骤撰写任务',
            runningWithRemaining: '预计还需 {remaining}',
            runningFinalizing: '正在收尾…',
            runningMetaWithEstimate: '已运行 {elapsed} · 预估会随进度更新',
            runningMetaWithElapsed: '已运行 {elapsed}',
            interrupting: '正在中断…',
        },

        duration: {
            seconds: '{count} 秒',
            minutes: '{count} 分钟',
            minutesSeconds: '{minutes} 分 {seconds} 秒',
        },

        browserNotification: {
            completedTabTitle: 'Hiro 任务已完成',
            failedTabTitle: 'Hiro 任务执行失败',
            inputRequiredTabTitle: 'Hiro 等待你的输入',
            completedTitle: 'Hiro 任务已完成',
            completedBody: '当前撰写任务已完成，可以返回查看结果。',
            failedTitle: 'Hiro 任务执行失败',
            failedBody: '当前撰写任务未完成，请返回查看详情。',
            inputRequiredTitle: 'Hiro 等待你的输入',
            inputRequiredBody: '当前任务需要你的确认或补充信息才能继续。',
        },

        // Agent 类型名称
        agentTypes: {
            disclosure: '技术交底书',
            prosecution: '答复审查意见',
            patent_draft: '专利撰写',
        },

        // 选中文本
        selectedText: {
            label: '选中文本：',
            clear: '清除选择',
        },

        // 快捷操作
        quickActions: {
            draft: {
                title: '撰写',
                icon: '🔍',
                description: '生成专利内容并分析现有技术',
                actions: [
                    '从交底书生成权利要求',
                    '撰写详细说明',
                    '查找相关专利',
                ],
            },
            refine: {
                title: '完善',
                icon: '✏️',
                description: '加强论证、优化结构并润色',
                actions: [
                    '发现薄弱论据并提供解决方案',
                    '添加执行摘要',
                    '查找并修复拼写错误',
                ],
            },
            format: {
                title: '格式化',
                icon: '🎨',
                description: '精确转换文档结构',
                actions: [
                    '根据内容推荐格式',
                    '为章节添加适当编号',
                    '生成目录',
                ],
            },
        },

        // 指令相关
        instructions: {
            select: '选择指令',
            refresh: '刷新指令列表',
            searchPlaceholder: '搜索指令...',
            noResults: '未找到相关指令',
            suggestionsTitle: '推荐指令',
            useThis: '使用此指令',
            navigate: '前往指令中心',
            instructionContent: '指令内容',
            description: '描述',
            tags: '标签',
            jurisdiction: '适用地区',
            createdAt: '创建时间',
            exampleOutput: '示例输出',
            close: '关闭',
        },

        // Pending 状态
        pending: {
            title: '需要你的输入',
            subtitle: 'Hiro 需要更多信息才能继续',
            inputLabel: '你的回答',
            waitingInfo: '等待你的确认或输入',
            tools: {
                askUser: '询问用户',
                task: '任务确认',
                todoWrite: '待办事项',
            },
        },

        // 决策表单
        decisionForm: {
            multiSelectHint: '(可多选)',
            inputPlaceholder: '请输入...',
            questionAdditionalPlaceholder: '如有补充说明，请在此输入...',
            submitted: '已提交',
            submit: '提交',
            cancel: '取消',
            loading: '加载决策表单...',
            parseError: '⚠️ 决策表单数据格式错误',
        },

        // 指令表单
        instructionForm: {
            kicker: '指令表单',
            fieldCount: '{count} 个字段',
            instructionContent: '指令内容',
            instructionContentPlaceholder: '可编辑本次要发送给 AI 的指令内容',
            inputPlaceholder: '请输入...',
            selectPlaceholder: '请选择',
            extraRequirement: '补充要求',
            extraRequirementPlaceholder: '可补充本次使用该指令时需要 AI 注意的信息',
            extraRequirementInline: '补充具体要求',
            directRun: '直接执行',
            charCount: '{count} 字',
            recognizedInstruction: '识别到「{name}」预设指令',
            detail: '详情',
            requiredError: '请填写「{label}」',
            emptyValue: '未填写',
            submit: '提交',
            submitted: '已提交',
            cancel: '取消',
            cancelled: '已取消',
            parseError: '指令表单数据格式错误',
            yes: '是',
            no: '否',
            outputInstructionName: '指令名称',
            outputInstructionDescription: '指令描述',
            outputInstructionContent: '指令内容',
            outputUserInputs: '补充要求',
            outputFieldDescription: '字段说明',
            outputUserAnswer: '补充要求',
            optionSourceClaims: '权利要求',
            optionSourceFigures: '附图',
            optionSourceSelect: '选择{source}',
            optionSourceReselect: '重新选择{source}（已选 {count}）',
            optionSourceTitle: '选择{source}',
            optionSourceHint: '从当前文档中解析可选内容，选择后会作为补充要求发送给 AI。',
            optionSourceRefresh: '重新解析',
            optionSourceLoading: '正在解析文档内容...',
            optionSourceEmpty: '未识别到{source}',
            optionSourceNoDocument: '未找到可解析的文档内容',
            optionSourceFailed: '解析失败',
            optionSourceRetry: '重试',
            optionSourceConfirm: '确认选择',
        },

        // 模板章节表单
        templateSectionForm: {
            kicker: '模板章节表单',
            sourceTemplate: '来源模板：{name}',
            sectionPrompt: '章节指令内容',
            sectionPromptPlaceholder: '可编辑本次要发送给 AI 的章节指令内容',
            extraRequirementPlaceholder: '可补充本次生成该章节时需要 AI 注意的信息',
            recognizedSection: '识别到「{name}」章节指令',
            parseError: '模板章节表单数据格式错误',
            outputSectionPrompt: '章节指令内容',
            sectionNames: {
                TITLE: '发明名称',
                BACKGROUND: '背景技术',
                SUMMARY_OF_INVENTION: '发明内容',
                BRIEF_DESCRIPTION_OF_FIGURES: '附图说明',
                CLAIMS: '权利要求',
                ABSTRACT: '摘要',
                DETAILED_DESCRIPTION: '具体实施方式',
                DETAILED_DESCRIPTION_PLAN: '具体实施方式大纲',
                REPEAT_CLAIMS: '重复权利要求',
                CUSTOM: '自定义章节',
            },
        },

        templateSectionPopover: {
            title: '模板章节指令',
            close: '关闭',
            insert: '插入到左侧文档',
            apply: '应用',
            instruction: 'AI 指令',
            noInstruction: '未配置 AI 指令',
            fromLibrary: '从库中选择',
            remove: '删除',
            addSection: '添加章节',
            newSection: '新章节',
            empty: '当前文档没有可用的模板章节',
            chars: '字符',
            fields: '字段',
        },

        // 任务建议
        suggestions: {
            title: '任务建议',
            agentLabels: {
                novelty: '专利查新智能体',
            },
        },

        // 引用内容
        reference: {
            label: '引用选中内容',
        },

        // 中断提示
        interrupting: {
            title: '正在停止执行',
            description: '正在安全地终止当前任务...',
            interrupted_by_user: '执行已被用户中断',
            processing: '正在处理...',
        },

        // 错误信息
        error: {
            technicalDetails: '技术详情 (仅开发环境)',
            errorCode: '错误代码：',
            permissionDeniedReadOnly: '当前为只读权限，无法发送消息',
            permissionDeniedEdit: '示例项目为只读，请{createLink}您自己的可编辑版本',
            createLink: '创建',
            permissionDeniedDelete: '当前权限不足，无法删除',
            permissionDeniedNoAccess: '无权访问此资源',
        },

        // 任务列表
        tasks: {
            completed: '已完成',
            markComplete: '标记为完成',
            collapse: '收起任务列表',
            expand: '展开查看全部任务',
        },

        // 工具相关
        toolCall: {
            result: '查看工具结果',
            toolResultLabel: '工具结果',
            toolResultHint: '此为工具执行的中间结果，最终内容请以「文档」中的版本为准',
            parameterDetails: '参数详情',
            executing: '执行中...',
            expand: '展开详情',
            collapse: '收起',
            betaBadge: 'Beta',
            spawnSteps: '{count} 个子步骤',
        },

        toolGroup: {
            title: '{title} 等 {count} 个步骤',
            stepCount: '{count} 个步骤',
            completedCount: '完成 {count}',
            runningCount: '执行中 {count}',
            failedCount: '失败 {count}',
        },

        // 图片预览
        imagePreview: {
            generatedImage: 'AI 生成图片',
            zoomIn: '放大',
            zoomOut: '缩小',
            download: '下载',
            close: '关闭',
        },

        // 附图生成
        imageGeneration: {
            title: '附图生成分析',
            promptLabel: '生成提示词',
            imagePreview: '生成结果',
            noImage: '暂无生成图片',
            failedTitle: '图片生成失败',
            timeoutError: '图片生成超时，请稍后重试。',
            genericError: '图片生成失败，请稍后重试。',
        },

        // 工具名称
        tools: {
            unknown: '工具调用',
            timeUnknown: '--:--',
            get_current_time: '获取当前时间',
            create_document: '创建文档',
            read_document: '读取文档',
            list_project_attachments: '列出项目附件',
            read_attachment_content: '读取附件内容',
            read_image: '读取图片',
            auto_annotate_image: '自动标注图片',
            intelligent_patent_search: '智能专利检索',
            get_patent_details: '获取专利详情',
            paper_semantic_search: '论文语义检索',
            web_search: '网络搜索',
            patent_drafting_tool: '专利撰写分析',
            // 专利撰写动态显示名：前缀 + 部分名（多于2个时折叠为「等N个部分」）
            draftingPrefix: '撰写',
            draftingMore: '等{count}个部分',
            draftingSections: {
                Claims: '权利要求',
                Title: '发明名称',
                Field: '技术领域',
                Background: '背景技术',
                Summary: '发明内容',
                Drawing_desc: '附图说明',
                Description: '具体实施方式',
                Abstract: '摘要',
                Outline: '大纲',
            },
            patent_rule_review_tool: '专利规则审查',
            review_oar_response: '审查答复文档核稿',
            extract_oa_and_generate_rejection_table: '提取审查意见并生成驳回分析表',
            extract_oa_analysis: '提取审查意见并生成驳回分析表',
            extract_oa_info: '提取审查意见',
            extract_raw_text: '提取原文内容',
            analyze_oa_rejections: '生成审查意见答复策略',
            generate_oa_strategy: '生成审查意见答复策略',
            generate_oar_content: '生成OAR内容',
            render_rejection_table: '展示驳回分析表',
            update_rejection_table: '更新驳回分析表',
            validate_oa_strategy: '验证审查意见答复策略',
            fetch_office_action_pdf: '获取审查意见PDF',
            fetch_historical_files: '获取历史文件',
            analyze_disclosure: '分析技术交底书',
            novelty_creativity_evaluation: '新颖性创造性评估',
            update_plan: '更新计划',
            read_style: '读取撰写风格',
            read_template: '读取模板',
            request_user_decision: '请求用户决策',
            load_skill: '加载技能',
            inject_agent_skill: '加载历史上下文',
            load_skill_content: '加载技能',
            detect_and_setup_patent_office: '检测并设置专利受理局',
            write_document: '撰写文档',
            express_generate_reply: '生成答复意见',
            check_express_eligibility: '检查生成条件',
            end_task: '结束任务',
            suggest_next_step: '建议下一步',
            verify_office_action: '验证审查意见通知书',
            analyze_oa_response_strategy: '分析审查意见答复策略',
            streaming: '工具输出中...',
            done: '工具调用已完成',
            generate_oar_document: '生成审查意见答复书',
            generate_image: '附图生成分析',
            convert_patent_figure: '专利附图生成',
            draw_patent_figures: '绘制专利附图',
            label_patent_figures: '标注专利附图',
            plan_patent_drawings: '规划专利附图方案',
            spawn_agent: '技术探索',
        },

        // 新颖性创造性评估渲染器
        noveltyEvaluation: {
            tabPatents: '对比专利',
            tabEvaluations: '评估报告',
            noData: '暂无数据',
            parseError: '数据解析失败',
        },

        // 专利搜索结果渲染器
        patentSearch: {
            found: '前{count}篇相关专利',
            searchResult: '搜索结果',
            expand: '展开',
            collapse: '收起',
            applicationDate: '申请日期',
            publicationDate: '公开日期',
            relevance: '相关度',
            parseError: '数据解析失败',
            showDetails: '专利详情',
            noData: '暂无数据',
            searchTypes: {
                semantic_search: '语义检索',
                structured_query: '结构化检索',
                patent_number: '专利号检索',
            },
        },

        // 专利详情渲染器
        // 浮动窗口
        floating: {
            minimize: '最小化',
            maximize: '最大化/还原',
            close: '关闭',
        },

        patentDetail: {
            basicInfo: '基本信息',
            patentNumber: '专利号',
            title: '标题',
            applicationNumber: '申请号',
            applicationDate: '申请日期',
            publicationDate: '公开日期',
            inventor: '发明人',
            applicant: '申请人',
            abstract: '摘要',
            copySection: '复制章节',
            copyAll: '复制全部',
            export: '导出',
            copySuccess: '已复制 {section}',
            copyFailed: '复制失败',
            exportSuccess: '导出成功',
            exportFailed: '导出失败',
            images: '附图',
            parseError: '数据解析失败',
            fallbackHint: '以下为原始内容：',
            textFormatError: '当前内容为文本格式，请在对话中查看完整内容。',
        },

        // 论文搜索结果渲染器
        paperSearch: {
            title: '论文语义检索',
            found: '找到 {count} 篇相关论文',
            noData: '暂无相关论文',
            parseError: '数据解析失败',
            showDetails: '查看详情',
            authors: '作者',
            journal: '期刊',
            publishTime: '发表时间',
            doi: 'DOI',
            citationCount: '被引次数',
            downloadPdf: '下载 PDF',
            searchModes: {
                text: '文本语义检索',
                paper: '相似论文检索',
                patent: '专利关联论文',
            },
        },

        // 论文详情渲染器
        paperDetail: {
            basicInfo: '基本信息',
            title: '标题',
            authors: '作者',
            journal: '期刊',
            publishTime: '发表时间',
            doi: 'DOI',
            citationCount: '被引次数',
            referenceCount: '参考文献数',
            organizations: '机构',
            abstract: '摘要',
            copyAll: '复制全部',
            export: '导出',
            copySuccess: '已复制 {section}',
            copyFailed: '复制失败',
            exportSuccess: '导出成功',
            exportFailed: '导出失败',
            parseError: '数据解析失败',
            fallbackHint: '以下为原始内容：',
        },

        // LLM 回放
        llmReplay: {
            title: '请求体',
            formView: '表单视图',
            jsonView: 'JSON视图',
            basicConfig: '基础配置',
            model: '模型',
            modelPlaceholder: '例如: claude-4.5-sonnet',
            temperature: '温度',
            maxTokens: '最大Token数',
            stream: '流式输出',
            reasoningEffort: '推理强度',
            selectPlaceholder: '请选择',
            messageList: '消息列表',
            addMessage: '添加消息',
            messageIndex: '消息 {index}',
            delete: '删除',
            role: '角色',
            rolePlaceholder: '请选择角色',
            content: '内容',
            contentPlaceholder: '请输入消息内容',
            jsonPlaceholder: '请输入JSON格式的请求体',
            jsonError: 'JSON格式错误: {message}',
            switchError: '无法切换: JSON格式错误',
            replayResult: '回放结果',
            fieldRole: '角色',
            fieldContent: '内容',
            finishReason: '完成原因',
            tokenUsage: 'Token 使用统计',
            promptTokens: '输入 Tokens:',
            completionTokens: '输出 Tokens:',
            totalTokens: '总计:',
            modelInfo: '模型信息',
            modelLabel: '模型:',
            createdAt: '创建时间:',
            requestId: '请求 ID:',
            statusIdle: '未开始',
            statusReplaying: '回放中',
            statusSuccess: '成功',
            statusError: '失败',
            preserveFieldsHint: '仅编辑原请求中已存在的基础参数；其他字段会原样保留。',
            addUserMessage: '添加 User 消息',
            newUserMessage: '新增 User 消息',
            userMessagePlaceholder: '输入下一轮消息，支持 Markdown',
            addToConversation: '添加到对话',
            emptyConversation: '当前请求中没有消息，可从下方添加 User 消息。',
            edit: '编辑',
            save: '保存',
            cancel: '取消',
            messageJsonError: '消息必须是包含 role 字段的 JSON 对象',
            additionalFields: '附加字段',
            rawMessage: '完整消息 JSON',
            toolDefinitions: '工具定义',
            addTool: '添加工具',
            rawToolDefinition: '完整工具定义 JSON',
            otherParameters: '其他请求参数',
            editOtherInJson: '这些字段会原样发送；如需修改，请切换到 JSON 视图。',
            requestMustBeObject: '请求体必须是 JSON 对象',
            reasoningContent: '推理内容',
            returnedToolCalls: '模型返回的工具调用',
            invalidToolArguments: 'Arguments 不是有效 JSON，下面保留原始字符串。',
            simulatedToolResult: '模拟 Tool 返回值',
            simulatedToolResultPlaceholder: '输入该工具调用的返回内容',
            rawToolCall: '完整 Tool Call JSON',
            messagesAdded: '消息已加入请求上下文',
            addToolCallAndResults: '添加工具调用及返回值',
            addAssistantMessage: '添加 Assistant 消息',
            completeToolResultsHint: '填写所有工具返回值后才能添加。',
            effectiveRequest: '实际发送请求',
            viewEffectiveRequest: '查看实际请求体',
            rawResponse: '完整原始响应',
            unrecognizedResponse: '无法识别响应结构，请查看完整原始响应。',
            validationFailed: '消息协议校验未通过',
        },
    },
};
